import axios from "./request";

//登录 -- 圣才
export const login = data => {
  return axios.request({
    url: "/official-website/mgnt/auth/login",
    data: data,
    method: "post"
  });
};
export const loginOut = data => {
  return axios.request({
    url: '/official-website/mgnt/auth/logout',
    method: "post"
  });
};
// 登录成功后调物业的
export const pmsLogin = data => {
  return axios.request({
    url: "/pms-service-user/user/pms-user-info",
    method: "get"
  });
};
//短信验证码登录
export function loginBySms (data) {
  return axios.request({
    url: '/official-website/mgnt/auth/loginByPhoneSms',
    data,
    method: 'post'
  })
}
//发送短信验证码
export const sendSms = data => {
  return axios.request({
    url: "/auth-service/api/auth/sendSms",
    method: "post",
    data
  });
};

//登出
export const logOut = data => {
  return axios.request({
    url: "/auth-service/api/auth/logout",
    method: "post"
  });
};

// 获取验证码
export const getVerificationCode = data => {
  return axios.request({
    url: "/auth-service/api/auth/getVerificationCode",
    method: "get",
    params: data
  });
};

// 校验验证码
export const vailVerificationCode = data => {
  return axios.request({
    url: "/auth-service/api/auth/vailVerificationCode",
    method: "post",
    data
  });
};

//获取当前用户 应用
export const getAppList = data => {
  data.appType = 1;
  return axios.request({
    url: "/auth-service/propertyAuthView/findAppMenuAuthByUserCode",
    params: data,
    method: "get"
  });
};

//获取菜单
export const getMenuList = data => {
  return axios.request({
    url: "/auth-service/menuPage/build-tree/user-menu-page",
    params: data,
    method: "get"
  });
};

//修改密码
export const resetPwd = data => {
  return axios.request({
    url: "/auth-service/user/update-password",
    data: data,
    method: "post"
  });
};

// 查询登录用户菜单权限树
export const getMenuArray = data => {
  return axios.request({
    url: `/auth-service/mgnt/permission/build-user-menu-tree/${data.platformCode}/WEBSITE`,
    // params: data,
    method: "get"
  });
};

// 获取授权平台
export function queryUserPlatform(data) {
  return axios.request({
    url: '/auth-service/mgnt/platform/queryUserPlatform',
    method: 'get',
    params: data
  })
}
// 获取用户详情
export function queryByAccount(data) {
  return axios.request({
    url: '/auth-service/mgnt/user/query-by-account',
    method: 'get',
    params: data
  })
}
// 获取用户下的平台
export function getUserPlatform() {
  return axios.request({
    url: '/official-website/platform/getUserPlatform',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js